<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>财务系统</el-breadcrumb-item>
            <el-breadcrumb-item>用户列表</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align: left">
        <el-col :span="24">
          <el-form :model="searchForm" :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-input size="small" clearable v-model="searchForm.searchName" placeholder="请输入公司名称或账户名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="SearchByName">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="addUser">添加用户</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row style="margin-top: -10px">
        <el-col :span="24">
          <el-table :data="UserList" style="width: 100%" row-key="Uid" v-loading="loading" size="small">
            <el-table-column prop="Account_name" label="账户名称"></el-table-column>
            <el-table-column prop="Company_name" label="公司名称"></el-table-column>
            <el-table-column prop="ComCity" label="地区"></el-table-column>
            <el-table-column prop="Phone" label="电话"></el-table-column>
            <el-table-column prop="Email" label="邮箱"></el-table-column>
            <el-table-column prop="Institution_number" label="社会信用编码"></el-table-column>

            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <el-button type="text" @click="GetSpecailTicket(scope.row)" size="small">专票信息</el-button>
                <el-button type="text" @click="renewalsDialog(scope.row)" size="small">转款记录</el-button>
                <el-button type="text" @click="getFinancialUserInfo(scope.row)" size="small">编辑用户</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount" style="float: right"></el-pagination>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog width="80%" :title="dialagTitle" :visible.sync="dialogTableVisible">
      <el-table :data="Renewals" style="width: 100%" v-loading="loading" size="small">
        <el-table-column prop="OrderNo" label="订单编号"></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间"></el-table-column>
        <el-table-column prop="OrderName" label="订单名称"></el-table-column>
        <el-table-column prop="UserName" label="用户名称"></el-table-column>
        <el-table-column prop="TotalMoney" label="支付金额"></el-table-column>
        <el-table-column prop="Coupon" label="优惠"></el-table-column>
        <el-table-column prop="PayType" :formatter="payType" label="支付方式"></el-table-column>
        <el-table-column prop="PayStatus" :formatter="payStatus" label="支付状态"></el-table-column>
        <el-table-column prop="PayTime" label="支付时间"></el-table-column>
        <el-table-column prop="TransferStatus" :formatter="TransferStatus" label="转款状态"></el-table-column>
        <el-table-column prop="TransferTime" label="转账时间"></el-table-column>
        <el-table-column prop="IsTicket" :formatter="isTicket" label="开具发票"></el-table-column>
        <el-table-column prop="result" :formatter="result" label="发票类型"></el-table-column>
        <el-table-column prop="msg" label="发票信息"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog width="30%" title="专票信息" :visible.sync="dialogZhuanpiaoVisible" top="10px">
      <el-form :model="SpecialTicket" :style="SpecialTicketInfoStyle">
        <el-form-item style="margin-bottom: 10px" label="账户ID:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.UserId }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="账户名称:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Account_name }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="公司名称:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.CompanyName }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="信用编码:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Institution_number }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="银行名称:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.BankName }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="银行账户:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Bank_Account }}</span>
          </div>
        </el-form-item>
        <!-- <el-form-item style="margin-bottom: 10px" label="收件人:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Recipients }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="收件电话:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Phone }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="开票地址:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Ticketaddress }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="开票电话:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.TicketPhone }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="邮寄地址:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Addressed }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="邮编:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Postalcode }}</span>
          </div>
        </el-form-item> -->
        <el-form-item style="margin-bottom: 10px" label="开票邮箱:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ SpecialTicket.Email }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="营业执照:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <el-image style="width: 100px; height: 100px"
              v-if="SpecialTicket.ImgUrl != null && SpecialTicket.ImgUrl.indexOf('http') > -1"
              :src="SpecialTicket.ImgUrl" :preview-src-list="[SpecialTicket.ImgUrl]">
            </el-image>
            <el-image style="width: 100px; height: 100px" v-else :src="'http://pay.ruizhiqi.cn' + SpecialTicket.ImgUrl"
              :preview-src-list="['http://pay.ruizhiqi.cn' + SpecialTicket.ImgUrl]">
            </el-image>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="主要资料:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <el-image style="width: 100px; height: 100px"
              v-if="SpecialTicket.FilePhoto != null && SpecialTicket.FilePhoto.indexOf('http') > -1"
              :src="SpecialTicket.FilePhoto" :preview-src-list="[SpecialTicket.FilePhoto]">
            </el-image>
            <el-image style="width: 100px; height: 100px" v-else
              :src="'http://pay.ruizhiqi.cn' + SpecialTicket.FilePhoto"
              :preview-src-list="['http://pay.ruizhiqi.cn' + SpecialTicket.FilePhoto]">
            </el-image>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="审核状态:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class>{{ AccountStatus }}</span>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 10px" label="审核备注:" :label-width="formLabelWidth">
          <div class="ticketinfo">
            <span class style="color: #ff0000;">{{ SpecialTicket.BecauseOf }}</span>
          </div>
        </el-form-item>
      </el-form>
      <!--<el-button type="primary" @click="dialogEditZhuanpiaoVisible = true">{{ operTicketBtnText }}</el-button>-->
      <el-button @click="dialogZhuanpiaoVisible = false" style="margin-left: 43%;">取 消</el-button>
      <el-dialog width="50%" title="专票信息" :visible.sync="dialogEditZhuanpiaoVisible" top="10px" append-to-body>
        <el-form :model="SpecialTicket" ref="ticketForm" :rules="ticketRules">
          <el-form-item label="账户名称" :label-width="formLabelWidth" prop="Account_name">
            <el-input v-model="SpecialTicket.Account_name" :disabled="disabled" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="账户ID" :label-width="formLabelWidth" prop="UserId">
            <el-input v-model="SpecialTicket.UserId" :disabled="disabled" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" :label-width="formLabelWidth" prop="CompanyName">
            <el-input v-model="SpecialTicket.CompanyName" :disabled="disabled" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮寄地址" :label-width="formLabelWidth" prop="Addressed">
            <el-input v-model="SpecialTicket.Addressed" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="银行账户" :label-width="formLabelWidth" prop="Bank_Account">
            <el-input v-model="SpecialTicket.Bank_Account" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="银行名称" :label-width="formLabelWidth" prop="BankName">
            <el-input v-model="SpecialTicket.BankName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="社会信用编码" :label-width="formLabelWidth" prop="Institution_number">
            <el-input v-model="SpecialTicket.Institution_number" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收件人电话" :label-width="formLabelWidth" prop="Phone">
            <el-input v-model="SpecialTicket.Phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮编" :label-width="formLabelWidth" prop="Postalcode">
            <el-input v-model="SpecialTicket.Postalcode" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收件人" :label-width="formLabelWidth" prop="Recipients">
            <el-input v-model="SpecialTicket.Recipients" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开票地址" :label-width="formLabelWidth" prop="Ticketaddress">
            <el-input v-model="SpecialTicket.Ticketaddress" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开票电话" :label-width="formLabelWidth" prop="TicketPhone">
            <el-input v-model="SpecialTicket.TicketPhone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开票邮箱" :label-width="formLabelWidth" prop="Email">
            <el-input v-model="SpecialTicket.Email" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="OpenSpecialTicket">保存</el-button>
          <el-button @click="dialogEditZhuanpiaoVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <el-dialog width="50%" title="用户信息" :visible.sync="dialogEditUserVisible" top="10px">
      <el-form :model="User" ref="userForm" :rules="userRules">
        <el-form-item label="账户ID" :label-width="formLabelWidth" prop="Uid">
          <el-input v-model="User.Uid" :disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="账户名称" :label-width="formLabelWidth" prop="Account_name">
          <el-input v-model="User.Account_name" :disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" :label-width="formLabelWidth" prop="Company_name">
          <el-input v-model="User.Company_name" :disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="社会信用代码" :label-width="formLabelWidth" prop="Institution_number">
          <el-input v-model="User.Institution_number" :disabled="disabled" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="formLabelWidth" prop="Phone">
          <el-input v-model="User.Phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth" prop="Email">
          <el-input v-model="User.Email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所在城市" :label-width="formLabelWidth" prop="ComCity">
          <!-- <el-input v-model="User.ComCity" autocomplete="off"></el-input> -->
          <el-select style="width: 100%" v-model="User.ComCity" placeholder="所在城市">
            <el-option v-for="item in ComCitys" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户状态" :label-width="formLabelWidth" prop="AccountStatus">
          <el-select style="width: 100%" v-model="User.AccountStatus" placeholder="账户状态">
            <el-option v-for="item in accountStatusOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="operFinancialUser">保存</el-button>
        <el-button @click="dialogEditUserVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetUserPageList,
  GetOrderPageList,
  GetSpecialTikets,
  AddSpecialTikets,
  UpdateSpecialTikets,
  GetSingleUserInfo,
  AddUserInfo,
  UpdateUserInfo,
} from "../../until/ZeusApiSDK/Logic/FinancialLogic";
import { EnqueueFinancialLog } from "../../until/ZeusApiSDK/Logic/LogLogic";
import {
  GetCurrentUserInfo,
  GetNewGuid,
  GetCurrentUserRole,
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import {
  isMobileNumber,
  isEmail,
  CheckFinancialUserOnly,
  CheckSpecialTicketsOnly,
  checkData,
} from "../../until/validate";
export default {
  data() {
    return {
      searchForm: { searchName: "" },
      UserList: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      dialogTableVisible: false,
      dialogZhuanpiaoVisible: false,
      dialogEditZhuanpiaoVisible: false,
      dialagTitle: "转账记录",
      Renewals: [],
      SpecialTicket: {},
      formLabelWidth: "120px",
      disabled: true,
      SpecialTicketInfoStyle: {
        display: "none",
      },
      AccountStatus: "",
      operTicketBtnText: "添加专票",
      dialogEditUserVisible: false,
      User: {},
      ComCitys: [
        {
          value: "郑州",
          label: "郑州",
        },
        {
          value: "开封",
          label: "开封",
        },
        {
          value: "南阳",
          label: "南阳",
        },
        {
          value: "信阳",
          label: "信阳",
        },
        {
          value: "驻马店",
          label: "驻马店",
        },
        {
          value: "商丘",
          label: "商丘",
        },
        {
          value: "濮阳",
          label: "濮阳",
        },
        {
          value: "平顶山",
          label: "平顶山",
        },
        {
          value: "周口",
          label: "周口",
        },
        {
          value: "鹤壁",
          label: "鹤壁",
        },
        {
          value: "漯河",
          label: "漯河",
        },
        {
          value: "许昌",
          label: "许昌",
        },
        {
          value: "新乡",
          label: "新乡",
        },
        {
          value: "焦作",
          label: "焦作",
        },
        {
          value: "安阳",
          label: "安阳",
        },
        {
          value: "洛阳",
          label: "洛阳",
        },
        {
          value: "济源",
          label: "济源",
        },
      ],
      accountStatusOptions: [
        {
          value: "0",
          label: "正常",
        },
        {
          value: "1",
          label: "失效",
        },
      ],
      userOperType: "add",
      userInfo: {},
      userRules: {
        //用户验证规则
        Uid: [
          { required: true, message: "请输入账户ID", trigger: "blur" },
          { validator: CheckFinancialUserOnly, trigger: "blur" },
          { validator: checkData, trigger: "blur" },
        ],
        Account_name: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
          { min: 2, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" },
        ],
        Phone: [
          { required: true, message: "请输入电话", trigger: "blur" },
          { validator: isMobileNumber, trigger: "blur" },
        ],
        Email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: isEmail, trigger: "blur" },
        ],
        Company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        ComCity: [
          { required: true, message: "请选择地区", trigger: "change" },
        ],
        Institution_number: [
          { required: true, message: "请输入社会信用编码", trigger: "blur" },
          { validator: checkData, trigger: "blur" },
        ],
        AccountStatus: [
          { required: true, message: "请选择账户状态", trigger: "change" },
        ],
      },
      ticketRules: {
        //专票验证规则
        Account_name: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
          { validator: CheckSpecialTicketsOnly, trigger: "blur" },
        ],
        CompanyName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        Addressed: [
          { required: true, message: "请输入邮寄地址", trigger: "blur" },
        ],
        Bank_Account: [
          { required: true, message: "请输入银行账户", trigger: "blur" },
        ],
        BankName: [
          { required: true, message: "请输入银行名称", trigger: "blur" },
        ],
        Institution_number: [
          { required: true, message: "请输入社会信用编码", trigger: "blur" },
          { validator: checkData, trigger: "blur" },
        ],
        Phone: [
          { required: true, message: "请输入收件人电话", trigger: "blur" },
          { validator: isMobileNumber, trigger: "blur" },
        ],
        Postalcode: [
          { required: true, message: "请输入邮编", trigger: "blur" },
        ],
        Recipients: [
          { required: true, message: "请输入收件人", trigger: "blur" },
        ],
        Ticketaddress: [
          { required: true, message: "请输入开票地址", trigger: "blur" },
        ],
        TicketPhone: [
          { required: true, message: "请输入开票电话", trigger: "blur" },
        ],
        Email: [
          { required: true, message: "请输入开票邮箱", trigger: "blur" },
          { validator: isEmail, trigger: "blur" }
        ],
      },
    };
  },
  created() {
    this.GetUserPageList();
    this.userInfo = GetCurrentUserInfo();
  },
  methods: {
    addUser: function () {
      this.disabled = false;
      this.User = {};
      (this.dialogEditUserVisible = true), (this.userOperType = "add");
    },
    renewalsDialog: function (row) {
      this.dialagTitle =
        row.Account_name + "转款记录(最近10条)  详情请前往转款记录页面查看";

      this.GetRenewalPageList(row.Account_name);
    },
    //验证
    checkData(rule, value, callback) {
      if (value) {
        if (/[\u4E00-\u9FA5]/g.test(value)) {
          callback(new Error("编码不能输入汉字!"));
        } else {
          callback();
        }
      }
      callback();
    },
    //更改每页显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetUserPageList();
    },
    //翻页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetUserPageList();
    },
    //搜索
    SearchByName: function () {
      this.pageIndex = 1;
      this.GetUserPageList();
    },
    //刷新
    Refresh: function () {
      this.GetUserPageList();
    },
    //获取单个用户
    getFinancialUserInfo: function (row) {
      this.disabled = true;
      this.userOperType = "update";
      GetSingleUserInfo(row.Uid).then((res) => {
        this.User = res;
        this.dialogEditUserVisible = true;
      });
    },
    //用户列表
    GetUserPageList: async function () {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      var currentUserRole = await GetCurrentUserRole();
      var isAll = "0";
      if (currentUserRole.Key == "admin") {
        isAll = "all";
      }
      // isAll = "all";
      GetUserPageList(
        userinfo.UserCode,
        isAll,
        this.pageIndex,
        this.pageSize,
        this.searchForm.searchName
      ).then((pageRes) => {
        this.UserList = pageRes.DataList;
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },
    //转款记录，本页面只显示最新的10条
    GetRenewalPageList: function (name) {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      var myDate = new Date();//获取系统当前时间
      var Year = myDate.getFullYear();
      var sdate = (Year - 10) + '-' + (myDate.getMonth() + 1) + '-' + (myDate.getDate() == 29 ? 28 : myDate.getDate());
      var edate = Year + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate();
      GetOrderPageList(userinfo.UserCode, "all", "1", "10", sdate, edate, name).then(
        (pageRes) => {
          if (pageRes.TotalCount > 0) {
            this.dialogTableVisible = true;
            this.Renewals = pageRes.DataList;
          } else {
            this.$message({
              message: "没有转款记录",
              type: "warning",
              center: true,
            });
          }
          this.loading = false;
        }
      );
    },
    //专票信息，每个账户只有一个
    GetSpecailTicket: function (row) {
      GetSpecialTikets(row.Account_name).then((res) => {
        this.dialogZhuanpiaoVisible = true;
        if (res instanceof Array) {
          if (res.length > 0) {
            this.disabled = true;
            this.operTicketBtnText = "编辑专票";
            this.SpecialTicketInfoStyle = { display: "block" };
            this.SpecialTicket = res[0];
            this.AccountStatus = this.accountStatus(
              this.SpecialTicket.AccountStatus
            );
            // var arr = Reflect.ownKeys(this.SpecialTicket);
            // arr.forEach(element => {
            // });
          } else {
            this.InitAddSpecialTicket(row);
          }
        } else {
          this.InitAddSpecialTicket(row);
        }
      });
    },
    InitAddSpecialTicket: function (row) {
      this.SpecialTicket.Account_name = row.Account_name;
      this.SpecialTicket.CompanyName = row.Company_name;
      this.SpecialTicket.UserId = row.Uid;
      this.disabled = false;
      this.SpecialTicketInfoStyle = { display: "none" };
      this.operTicketBtnText = "添加专票";
      this.disabled = false;
    },
    //添加或编辑专票
    OpenSpecialTicket: function () {
      if (this.SpecialTicket.Id) {
        this.ticketRules.Account_name = [
          { required: true, message: "请输入账户名称", trigger: "blur" },
        ];
      } else {
        this.ticketRules.Account_name = [
          { required: true, message: "请输入账户名称", trigger: "blur" },
          { validator: CheckSpecialTicketsOnly, trigger: "blur" },
        ];
      }
      this.$refs["ticketForm"].validate((valid) => {
        if (valid) {
          if (this.SpecialTicket.Id) {
            //根据是否存在ID区别是添加还是编辑
            GetSpecialTikets(this.SpecialTicket.Account_name).then((old) => {
              UpdateSpecialTikets(this.SpecialTicket).then((res) => {
                var message = res ? "更新成功" : "更新失败";
                if (res) {
                  this.$message({
                    message: message,
                    type: "success",
                    center: true,
                  });
                } else {
                  this.$message({
                    message: message,
                    type: "danger",
                    center: true,
                  });
                }
                this.dialogZhuanpiaoVisible = false;
                this.dialogEditZhuanpiaoVisible = false;
                EnqueueFinancialLog(
                  //日志
                  "编辑专票",
                  this.userInfo.UserId,
                  this.userInfo.TrueName,
                  "编辑",
                  message,
                  this.SpecialTicket.UserId,
                  this.SpecialTicket,
                  old[0],
                  "financialTicket"
                );
              });
            });
          } else {
            GetNewGuid().then((id) => {
              this.SpecialTicket.Id = id;
              AddSpecialTikets(this.SpecialTicket).then((res) => {
                var message = res ? "添加成功" : "添加失败";
                if (res) {
                  this.$message({
                    message: message,
                    type: "success",
                    center: true,
                  });
                } else {
                  this.$message({
                    message: message,
                    type: "danger",
                    center: true,
                  });
                }
                EnqueueFinancialLog(
                  //日志
                  "添加专票",
                  this.userInfo.UserId,
                  this.userInfo.TrueName,
                  "添加",
                  message,
                  this.SpecialTicket.UserId,
                  this.SpecialTicket,
                  null,
                  "financialTicket"
                );
                this.dialogZhuanpiaoVisible = false;
                this.dialogEditZhuanpiaoVisible = false;
              });
            });
          }
        } else {
          return false;
        }
      });
    },
    operFinancialUser: function () {
      if (this.userOperType == "add") {
        this.userRules.Uid = [
          { required: true, message: "请输入账户ID", trigger: "blur" },
          { min: 6, max: 10, message: '账户ID长度不正确', trigger: "blur" },
          { validator: CheckFinancialUserOnly, trigger: "blur" },
          { validator: checkData, trigger: "blur" },
        ];
      } else {
        this.userRules.Uid = [
          { required: true, message: "请输入账户ID", trigger: "blur" },
          { min: 6, max: 10, message: '账户ID长度不正确', trigger: "blur" },
          { validator: checkData, trigger: "blur" },
        ];
      }
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          if (this.userOperType == "add") {
            var userinfo = GetCurrentUserInfo();
            AddUserInfo(userinfo.UserCode, this.User).then((res) => {
              var message = res ? "添加成功" : "添加失败";
              if (res) {
                this.$message({
                  message: message,
                  type: "success",
                  center: true,
                });
                this.GetUserPageList();
              } else {
                this.$message({
                  message: message,
                  type: "danger",
                  center: true,
                });
              }
              this.dialogEditUserVisible = false;
              this.userOperType = "add";
              EnqueueFinancialLog(
                //日志
                "添加用户",
                this.userInfo.UserId,
                this.userInfo.TrueName,
                "添加",
                message,
                this.User.Uid,
                this.User,
                null,
                "financialUser"
              );
            });
          } else {
            GetSingleUserInfo(this.User.Uid).then((old) => {
              UpdateUserInfo(this.User).then((res) => {
                var message = res ? "更新成功" : "更新失败";
                if (res) {
                  this.$message({
                    message: message,
                    type: "success",
                    center: true,
                  });
                  this.GetUserPageList();
                } else {
                  this.$message({
                    message: message,
                    type: "danger",
                    center: true,
                  });
                }
                this.dialogEditUserVisible = false;
                EnqueueFinancialLog(
                  //日志
                  "编辑用户",
                  this.userInfo.UserId,
                  this.userInfo.TrueName,
                  "编辑",
                  message,
                  this.User.Uid,
                  this.User,
                  old,
                  "financialUser"
                );
              });
            });
          }
        } else {
          return false;
        }
      });
    },
    accountStatus: function (status) {
      if (status == 0) {
        return "待审核";
      } else if (status == -1) {
        return "不通过";
      } else if (status == 1) {
        return "通过";
      } else if (status == 8) {
        return "冻结";
      }
    },
    payType(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "支付宝支付";
      } else if (cellValue == 1) {
        return "微信支付";
      } else if (cellValue == 2) {
        return "中信微信";
      } else if (cellValue == 3) {
        return "中信支付宝";
      } else if (cellValue == 4) {
        return "民生私对公";
      } else if (cellValue == 5) {
        return "代付款";
      } else if (cellValue == 6) {
        return "公对公转账";
      } else if (cellValue == 7) {
        return "民生公对公";
      } else if (cellValue == 8) {
        return "新开户";
      } else if (cellValue == 9) {
        return "手动转账";
      } else if (cellValue == 12) {
        return "光大微信";
      } else if (cellValue == 13) {
        return "光大支付宝";
      }
    },
    payStatus(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "未支付";
      } else if (cellValue == 1) {
        return "已支付";
      }
    },
    result(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "普票";
      } else if (cellValue == 1) {
        return "专票";
      }
    },
    isTicket(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "未开具";
      } else if (cellValue == 1) {
        return "已开具";
      }
    },
    //判断转账状态
    TransferStatus(row, column, cellValue, index) {
      if (cellValue == 0 || cellValue == -1) {
        return "未转账";
      } else if (cellValue == 1) {
        return "已转账";
      } else if (cellValue == 2) {
        return "不转账";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.ticketinfo {
  text-align: left !important;
}

::v-deep .el-dialog__body {
  padding-bottom: 30px !important;
}
</style>
